import { useEffect, useContext, useState } from "react";
import { Navigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { login } from "../../config/apiSPA.js";
import { homePage } from "../../config/configSPA.js";

function PagesLogin() {
  const context = useContext(AppSettings);
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();
  const [psw, setPsw] = useState();
  const [enable, setEnable] = useState(false);
  const [failLog, setFailLog] = useState(false);

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentClass("");
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      await login(event.target[0].value, event.target[1].value);
      setRedirect(true);
    } catch (error) {
      setLoading(false);
      setFailLog(true);
    }
  };

  function handleChangeUser(val) {
    setUser(val);
  }
  function handleChangePsw(val) {
    setPsw(val);
  }

  useEffect(() => {
    if (user && psw) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [user, psw]);

  if (redirect) {
    return <Navigate to={homePage} />;
  }
  return (
    <div className="login">
      <div className="login-content">
        <form onSubmit={handleSubmit}>
          <div className="text-center">
            <img src="assets/img/logo/ppd.png" alt="ppd logo" height="40" />
          </div>
          <h1 className="text-center">Sign In</h1>
          <div className="text-inverse text-opacity-50 text-center mb-4">For your protection, please verify your identity.</div>
          {failLog ? <div className="text-danger text-center">Sorry... invalid user name or password.</div> : ""}
          <div className="mb-3">
            <label className="form-label">
              User Name <span className="text-danger">*</span>
            </label>
            <input onChange={(e) => handleChangeUser(e.target.value)} type="text" className="form-control form-control-lg bg-white bg-opacity-5" placeholder="" />
          </div>
          <div className="mb-3">
            <div className="d-flex">
              <label className="form-label">
                Password <span className="text-danger">*</span>
              </label>
            </div>
            <input onChange={(e) => handleChangePsw(e.target.value)} type="password" className="form-control form-control-lg bg-white bg-opacity-5" placeholder="" />
          </div>

          {loading ? (
            <div className="text-center">
              <div className="spinner-border"></div>
            </div>
          ) : (
            <button type="submit" disabled={enable ? false : true} className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3">
              Sign In
            </button>
          )}
        </form>
      </div>
    </div>
  );
}

export default PagesLogin;
